export type ExtraChargeDisplayCurrency = 'krw' | 'foreign';

const FOREIGN_CURRENCY_SUPPLIERS = new Set(['ZE', 'ZR', 'OT']);

export const getExtraChargeDisplayCurrency = (
  supplier?: string | null,
): ExtraChargeDisplayCurrency =>
  supplier && FOREIGN_CURRENCY_SUPPLIERS.has(supplier) ? 'foreign' : 'krw';
